<div class="agpr-landingPageSidebar" [id]="id">
    <div class="agpr-landingPageSidebar-title">
        <h2 class="agpr-landingPageSidebar-title-text">{{ title | localize }}</h2>
    </div>
    @if (description) {
        <div class="agpr-landingPageSidebar-description">
            {{ description | localize }}
        </div>
    }
    <ul class="agpr-landingPageSidebar-feeds">
        <li
            *ngFor="let feed of feeds; let i = index"
            class="agpr-landingPageSidebar-feed"
            [ngClass]="{
                'agpr-landingPageSidebar-prNews': isPrNews,
                'agpr-landingPageSidebar-agilityNews': isAgilityNews,
            }"
        >
            @if (isAgilityNews) {
                <div class="agpr-landingPageSidebar-agilityNews-date">
                    {{feed.date | date: agilityDateFormat}}
                </div>
                <div class="agpr-landingPageSidebar-agilityNews-link">
                    <span>
                        <a
                            class="agpr-landingPageSidebar-link"
                            target="_blank"
                            [pTooltip]="feed.decodedTitle"
                            [showDelay]="500"
                            tooltipPosition="top"
                            [href]="feed.link"
                            [attr.aria-describedby]="id + '_landingPageSidebar_feed_externalLink' + i"
                        >
                            <span [innerHTML]="feed.title"></span>
                            <span [id]="id + '_landingPageSidebar_feed_externalLink' + i" class="u-srOnly">{{ 'Dashboard.sidebar.externalLink' | localize }}</span>
                            <i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square agpr-landingPageSidebar-feed-arrowIcon"></i>
                        </a>

                    </span>
                </div>
            }@else {
                <span>
                    <a
                        class="agpr-landingPageSidebar-link"
                        target="_blank"
                        [pTooltip]="feed.decodedTitle"
                        [showDelay]="500"
                        tooltipPosition="top"
                        [href]="feed.link"
                        [attr.aria-describedby]="id + '_landingPageSidebar_feed_externalLink' + i"
                    >
                        <span [innerHTML]="feed.title"></span>
                        <span [id]="id + '_landingPageSidebar_feed_externalLink' + i" class="u-srOnly">{{ 'Dashboard.sidebar.externalLink' | localize }}</span>
                        <i aria-hidden="true" class="fa-solid fa-arrow-up-right-from-square agpr-landingPageSidebar-feed-arrowIcon"></i>
                    </a>

                  </span>
            }
            @if (showAuthor) {
                <div class="agpr-landingPageSidebar-info">
                    <div class="agpr-landingPageSidebar-author">
                        {{ feed.author }} - {{ feed.date | date: dateFormat }}
                    </div>
                    <agpr-chip-container
                        [id]="id + '_subjectChips'"
                        [chips]="feed.category ? [feed.category] : []"
                        [readonly]="true"
                        [plainMode]="true"
                    ></agpr-chip-container>
                </div>
            }
        </li>
    </ul>

    <div
        class="agpr-landingPageSidebar-view-all"
    >
        <div class="agpr-landingPageSidebar-view-allText">
            <span>
                <a
                    class="agpr-landingPageSidebar-link agpr-landingPageSidebar-view-all-link"
                    target="_blank"
                    [href]="viewAll"
                    [attr.aria-describedby]="id + '_landingPageSidebar_viewAll_externalLink'"
                >
                    {{ 'Dashboard.sidebar.viewAll' | localize }}
                    <span [id]="id + '_landingPageSidebar_viewAll_externalLink'" class="u-srOnly">{{ 'Dashboard.sidebar.externalLink' | localize }}</span>
                    <i aria-hidden="true" class="fa-regular fa-arrow-up-right-from-square agpr-landingPageSidebar-feed-arrowIcon"></i>
                </a>
            </span>
        </div>
    </div>
</div>
